import { useCallback } from 'react'

let offset = 0

export function useSidebarScroll() {
  return useCallback((node: HTMLDivElement | null) => {
    if (!node) return
    node.scrollTop = offset
    const onScroll = () => {
      offset = node.scrollTop
    }
    node.addEventListener('scroll', onScroll, { passive: true })
    return () => node.removeEventListener('scroll', onScroll)
  }, [])
}
